<template>
  <vs-popup title="Clôture de la demande" :active.sync="isPromptActiveLocal">
    <vs-row>
      <vs-col vs-w="12">
        <vs-input
          v-model="form.title"
          class="w-full"
          label="Titre de la demande"
        /><br />
      </vs-col>
      <vs-col vs-w="7" type="flex">
        <vs-input
          v-model="form.email"
          :danger="error"
          :danger-text="error ? 'Email incorrect' : ''"
          class="w-full"
          label="Envoyer à"
        /><br />
      </vs-col>
      <vs-col vs-w="5" type="flex">
        <vs-input
          type="number"
          label="Numéro de téléphone"
          v-model="form.phone"
        /><br />
      </vs-col>
      <vs-col vs-w="12">
        <div>
          <label for="" class="vs-input--label">Mettre en copie</label>
        </div>
        <v-select
          v-model="form.copy"
          taggable
          multiple
          class="w-full"
          push-tags
          label="title"
          :options="options"
        /><br />
      </vs-col>
      <vs-col vs-w="12">
        <vs-textarea
          rows="6"
          label="Contenu du message"
          v-model="form.message"
        />
      </vs-col>
      <vs-divider>Fichiers joins</vs-divider>
      <vs-col vs-w="12">
        <div class="upload-img mt-1 mb-4">
          <input
            type="file"
            class="hidden"
            ref="uploadimgInput"
            @change="updateCurrimg"
            accept="*/*"
          />
          <vs-button size="small" @click.prevent="$refs.uploadimgInput.click()"
            >Joindre un fichier</vs-button
          >
        </div>

        <template v-if="form.img && form.img.length > 0">
          <h5>Fichier joints</h5>
          <div v-for="(img, index) in form.img" :key="index">
            <div class="modify-img flex justify-between mt-5">
              <div class="mail__attachment">
                <vs-chip color="grey" class="ml-2 mr-3 cursor-pointer">
                  <vs-avatar icon="cloud_download" />
                  {{ form.img_names[index] }}
                </vs-chip>
              </div>
              <vs-button size="small"
                type="border"
                color="danger"
                @click.prevent="updateCurrimgSupprimer(form.img_names[index])"
                >Supprimer</vs-button
              >
            </div>
          </div>
        </template>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="12" type="flex" v-if="info.close_request == '1'">
        <vs-button
          color="primary"
          @click="closeRequest()"
          class="mt-4 mr-2"
          type="filled"
          >Clôturer avec feedback</vs-button
        >
        <vs-button
          color="primary"
          class="mt-4"
          type="border"
          @click="closeNotFeedBack()"
          >Clôturer sans feedback</vs-button
        >
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="12" type="flex" v-if="info.close_request == '2'">
        <vs-button
          color="primary"
          @click="closeRequest()"
          class="mt-4 mr-2"
          type="filled"
          >Envoyer le feedback</vs-button
        >
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
//import {_buildQuery} from "../../helpers/helper";
let base_self;
export default {
  name: "close",
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    info: {
      type: Object,
      default: () => {},
    },
    callback: {
      type: Function,
      required: true,
    },
    callbackNoFeedBack: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    options: [],
    form: {},
    error: false,
  }),
  watch: {
    isPromptActive(val) {
      if (val) {
        this.form = this.info;
        this.options = this.form.copy;
      } else {
        this.form = {};
        this.options = [];
      }
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },
  methods: {
    closeNotFeedBack() {
      this.callbackNoFeedBack();
      this.$emit("closePrompt");
    },
    closeRequest() {
      if (
        this.form.title != "" &&
        this.form.email != "" &&
        this.form.message &&
        this.form.phone
      ) {
        if (this.validateEmail(this.form.email)) {
          this.callback(this.form);
          this.$emit("closePrompt");
        } else this.error = true;
      } else {
        window.GETCCMT.error({
          message:
            "Veuillez saisir un contenu dans le champs suivant: (titre, email, téléphone et message)",
        });
      }
    },

    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    updateCurrimg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          console.log(base_self.form);
          base_self.form.img_names.push(input.srcElement.files[0].name);
          base_self.form.img.push(e.target.result);
          base_self.form.files.push(this.$refs.uploadimgInput.files[0]);
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    updateCurrimgSupprimer(img_name) {
      var length = this.form.img_names ? this.form.img_names.length : 0;
      for (let iuoy = 0; iuoy < length; iuoy++) {
        var item = this.form.img_names[iuoy];
        if (img_name === item) {
          this.form.img_names.splice(iuoy, 1);
          this.form.img.splice(iuoy, 1);
          this.form.files.splice(iuoy, 1);
          break;
        }
      }
    },
  },
  created() {
    base_self = this;
  }
};
</script>

<style lang="scss" scoped>
</style>
